import { TikTokClientError } from "./client.error";

export class CaptchaError extends TikTokClientError {}
